import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Container, Stack, Typography } from "@mui/material";
import { Logo } from "../Logo";

const SimpleHeader = ({}) => {
    return (
        <header>
            <Container maxWidth="xl" sx={{ minHeight: "auto", padding: 0, alignItems: "start" }}>
                <Stack sx={{ height: "64px", alignItems: "center", flexDirection: "row" }}>
                    <Stack sx={{ alignItems: "center", flexDirection: "row", marginTop: "5px" }}>
                        <Logo></Logo>
                    </Stack>
                </Stack>
            </Container>
        </header>
    );
};

export { SimpleHeader };
